export default "__VITE_ASSET__1147ea02__"